var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValues(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "cureent",
    height: "cureent",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83796 21.1655C8.64889 20.2368 7.6858 19.0507 7.02108 17.6962C6.35636 16.3418 6.00731 14.8543 6.00015 13.3456C5.9702 7.92527 10.34 3.4195 15.7589 3.29196C17.8587 3.2414 19.9212 3.85329 21.6537 5.04085C23.3862 6.2284 24.7008 7.93132 25.411 9.90805C26.1212 11.8848 26.191 14.0349 25.6104 16.0536C25.0299 18.0722 23.8284 19.8567 22.1766 21.1541C21.8127 21.436 21.5178 21.7969 21.3139 22.2096C21.1101 22.6223 21.0028 23.0759 21 23.5361L21 24.2891C21 24.5544 20.8947 24.8087 20.7071 24.9962C20.5196 25.1838 20.2652 25.2891 20 25.2891H12C11.7348 25.2891 11.4804 25.1838 11.2929 24.9962C11.1053 24.8087 11 24.5544 11 24.2891L11 23.5353C10.9988 23.078 10.8936 22.627 10.6923 22.2164C10.491 21.8058 10.1988 21.4464 9.83796 21.1655Z",
    fill: "#FFDC3F",
    stroke: "#FFDC3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28.7109H21M16 24.7109V17.7109M16 17.7109L12 13.7109M16 17.7109L20 13.7109",
    stroke: "#FFF1B4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28.7109H21",
    stroke: "#9D621D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.439 6.17773C20.3745 6.61675 22.3088 7.87326 22.561 9.38721",
    stroke: "#FEE885",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/Values.36601575074a5d57f4d212c783a55fd8.svg";
export { ForwardRef as ReactComponent };